/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../_metronic/_helpers";
import { pagesLinks } from "../../../utils/PageUtils";

const AsideMenuListContainer = (props) => {
  const location = useLocation();
  const layoutProps = props.layoutProps;
  const getMenuItemActive = (url, hasSubmenu) => {
    return checkIsActive(location, url)
      ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
      : "";
  };

  useEffect(() => {

  }, []);


  return (
    <>
      {/* begin::Menu Nav */}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item ${getMenuItemActive("/dashboard", false)}`}
          aria-haspopup="true"
        >
          <NavLink className="menu-link" to="/dashboard">
            <div className="menu-icon menu-svg-dashboard"></div>
            <span className="menu-text">HomePage</span>
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/* Caricamento Massivo */}
        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-submenu ${getMenuItemActive(
            pagesLinks.multicheck, true
          )}`}
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <NavLink className="menu-link menu-toggle" to={pagesLinks.multicheck}>
            <div className="menu-icon menu-svg-settings"></div>
            <span className="menu-text">Caricamento massivo</span>
            {/* <i className="menu-arrow" /> */}
          </NavLink>
          {/* <div className="menu-submenu ">
            <i className="menu-arrow" />
            <ul className="menu-subnav">
              <li className="menu-item  menu-item-parent" aria-haspopup="true">
                <span className="menu-link">
                  <span className="menu-text">Caricamento massivo</span>
                </span>
              </li>

            </ul>
          </div> */}
        </li>
        {/*end::1 Level*/}

      </ul>

      {/* end::Menu Nav */}
    </>
  );
}

const mapStateToProps = function (state) {
  return {
  }
}

const mapDispatchToProps = dispatch => {
  return {
  }
}

export const AsideMenuList = connect(mapStateToProps, mapDispatchToProps)(AsideMenuListContainer);